import { createContext, useContext } from 'react'
import type { Me } from '../domain/schemas'
import type { Api } from '../infra/api'

export interface ApiCtx {
  api: Api
  me: Me
}

export const ApiContext = createContext<ApiCtx | null>(null)

export function useApi(): ApiCtx {
  const c = useContext(ApiContext)
  if (!c) throw new Error('useApi outside the API gate')
  return c
}
